import React from 'react'
import styled from 'styled-components'
import { devices } from 'Utils/devices'

const IconContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height:  75px;  
`
const SVG = styled.svg`
  ${({isFromWidgetChoice}) => isFromWidgetChoice && `
    @media ${devices.tablet} {
      width: 40px; 
      height: 40px;
    }`
  }
`

const ChartBarIcon = ({
  isFromWidgetChoice
}) => (
  <IconContainer>
    <SVG xmlns="http://www.w3.org/2000/svg" width="65.727" height="68.161" isFromWidgetChoice={isFromWidgetChoice} viewBox="0 0 65.727 68.161">
      <g className="fillHoverSVG" id="chart_bar" transform="translate(-9.692)">
        <g id="Groupe_2991" data-name="Groupe 2991" transform="translate(9.692)">
          <g id="Groupe_2990" data-name="Groupe 2990" transform="translate(0)">
            <path className="fillHoverSVG" id="Tracé_1258" data-name="Tracé 1258" d="M25.217,312.343H37.389a1.217,1.217,0,0,0,1.217-1.217V289.217A1.217,1.217,0,0,0,37.389,288H25.217A1.217,1.217,0,0,0,24,289.217v21.909A1.217,1.217,0,0,0,25.217,312.343Zm1.217-21.909h9.737v19.475H26.434Z" transform="translate(-24 -244.182)" fill="#707070"/>
            <path className="fillHoverSVG" id="Tracé_1259" data-name="Tracé 1259" d="M249.217,230.949h12.172a1.217,1.217,0,0,0,1.217-1.217V193.217A1.217,1.217,0,0,0,261.389,192H249.217A1.217,1.217,0,0,0,248,193.217v36.515A1.217,1.217,0,0,0,249.217,230.949Zm1.217-36.515h9.737v34.08h-9.737Z" transform="translate(-213.92 -162.788)" fill="#707070"/>
            <path className="fillHoverSVG" id="Tracé_1260" data-name="Tracé 1260" d="M137.217,149.555h12.172a1.217,1.217,0,0,0,1.217-1.217V97.217A1.217,1.217,0,0,0,149.389,96H137.217A1.217,1.217,0,0,0,136,97.217v51.121A1.217,1.217,0,0,0,137.217,149.555Zm1.217-51.121h9.737v48.686h-9.737Z" transform="translate(-118.96 -81.394)" fill="#707070"/>
            <path className="fillHoverSVG" id="Tracé_1261" data-name="Tracé 1261" d="M361.217,68.161h12.172a1.217,1.217,0,0,0,1.217-1.217V1.217A1.217,1.217,0,0,0,373.389,0H361.217A1.217,1.217,0,0,0,360,1.217V66.944A1.217,1.217,0,0,0,361.217,68.161Zm1.217-65.727h9.737V65.727h-9.737Z" transform="translate(-308.879)" fill="#707070"/>
          </g>
        </g>
      </g>
    </SVG>
  </IconContainer>
)

export default ChartBarIcon